// extracted by mini-css-extract-plugin
export var blogTitle = "Header-module--blog-title--fac1d";
export var button = "Header-module--button--6929f";
export var ctaNav = "Header-module--cta-nav--9c70d";
export var fullLogo = "Header-module--full-logo--821c3";
export var hideSlide = "Header-module--hide-slide--2ffa0";
export var highLevelLink = "Header-module--high-level-link--74f1d";
export var itemDesc = "Header-module--item-desc--d658f";
export var logo = "Header-module--logo--6d753";
export var london = "Header-module--london--cddab";
export var menuItem = "Header-module--menu-item--f6b42";
export var menuItemLink = "Header-module--menu-item-link--c43d0";
export var showSlide = "Header-module--show-slide--272aa";
export var siteHeader = "Header-module--site-header--c2e4d";
export var siteNav = "Header-module--site-nav--9c933";
export var slide = "Header-module--slide--e1965";
export var slideAnimation = "Header-module--slideAnimation--e008a";
export var sparkButton = "Header-module--spark-button--60b2c";
export var sparkLogo = "Header-module--spark-logo--65220";
export var sparkLondon = "Header-module--spark-london--31a1c";
export var sparkTitle = "Header-module--spark-title--a743c";
export var sticky = "Header-module--sticky--9b496";
export var subNav = "Header-module--sub-nav--fe96e";
export var svgImg = "Header-module--svgImg--7682a";